export function createTimestampGenerator(useTimeObj: true): () => { now: number, last: number, timeline: string };
export function createTimestampGenerator(useTimeObj?: boolean): () => string;
export function createTimestampGenerator(useTimeObj?: boolean): () => string | {
    now: number,
    last: number,
    timeline: string
} {
    let last = performance.now();
    return () => {
        const now = performance.now();
        const timeline = `@${~~now} +${(now - last).toFixed(2)}ms`;
        const timeObj = { now, last, timeline };
        last = now;
        return useTimeObj ? timeObj : timeline;
    };
}

export function formatError(err: { name?: string; message?: string; stack?: string; code?: number | string }) {
    const stack = `${err.name || 'Error'}: ${err.message || 'Unknown error'}} ${err.stack || ''}`;
    return `${stack} ${err.code ? `(${err.code})` : ''}`;
}
